import {
  FETCH_ADMIN_AFFILIATES_REQUEST,
  FETCH_ADMIN_AFFILIATES_SUCCESS,
  FETCH_ADMIN_AFFILIATES_FAILURE,
} from '../../actions/adminAffiliates/adminAffliatesActionType';

const initialState = {
  loading: false,
  affiliates: [],
  error: '',
  fetched: false,
};

interface Affiliates {
  AffiliateID: number;
  AffiliateName: string;
  SalesMarkets: Array<string>;
}
interface YearWeek {
  value: number;
  label: string;
}
interface YearWeeks {
  Year: YearWeek;
  Week: YearWeek;
}
interface Payload {
  Affiliates: Affiliates;
  CurrentTokenExpiry: string;
  Email: string;
  IsAdmin: boolean;
  IsNewPassword: boolean;
  Name: string;
  Password: any;
  Roles: Array<string>;
  Token: string;
  YearWeeks: YearWeeks;
}
interface AdminAction {
  payload: Payload;
  type: string;
}

const adminAffiliateReducer = ( state = initialState, action: AdminAction):any => {
  switch (action.type) {
    case FETCH_ADMIN_AFFILIATES_REQUEST:
      return {
        ...state,
        loading: true,
        fetched: false,
      };
    case FETCH_ADMIN_AFFILIATES_SUCCESS:
      return {
        ...state,
        loading: false,
        affiliates: action.payload,
        error: '',
        fetched: true,
      };
    case FETCH_ADMIN_AFFILIATES_FAILURE:
      return {
        ...state,
        loading: false,
        affiliates: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default adminAffiliateReducer;
